import React, { useState, useRef, useEffect, useContext } from "react";
import PerfectScrollbar from "perfect-scrollbar";
import { matchPath, Route, Routes, useLocation, Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import routes from "routes.jsx";
// import { Menu, X, Map } from "lucide-react";
import WelcomSection from "views/Dashboard/WelcomSection";
import useFetchRecruiter from "hooks/useFetchRecruiter";
import { Box, Typography, Button } from "@mui/material";
import { COLORS } from "colors/color";
import { VideoCallContext } from "store/VideoCallContext";
import Navbar from "components/Navbars/nav";
import { useTheme, useMediaQuery } from "@mui/material";
import { useTour } from "context/TourContext";
// import { useTour } from "context/TourContext";
// import useAutoTour from "hooks/useAutoTour";
import AIAssistant from "views/ai-assistant";
import useUserId from "hooks/useUserId";

const Wrapper = styled.div`
  display: flex;
  background-color: #f4f5f7;
`;

const MainPanel = styled(Box)(({ isSidebarCollapsed }) => ({
  flex: 1,
  minHeight: '100vh',
  marginLeft: isSidebarCollapsed ? 80 : 270,
  transition: 'margin-left 0.3s ease',
  backgroundColor: '#F4F5F7',
  position: 'relative',
  overflowY: 'auto',
  overflowX: 'hidden',
 
  '@media (max-width: 768px)': {
    marginLeft: 0,
    paddingTop: 0
  },
  '&::before': {
    content: '""',
    display: 'none',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    height: '60px',
    backgroundColor: 'white',
    zIndex: 1100
  }
}));

const NavbarWrapper = styled.div`
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1030;
  background-color: white;
  width: 100%;

  @media (max-width: 768px) {
    left: 0;
  }
`;

const ContentWrapper = styled.div`
  width: 100%;
  padding: 0;
  box-sizing: border-box;
  margin: 0;
  height: auto;
`;

const MobileMenuToggle = styled.button`
  display: none;
  
  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1040;
    width: 48px;
    height: 48px;
    border-bottom-right-radius: 16px;
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border: none;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.3);
    }

    svg {
      color: #374151;
    }
  }
`;

const MobileSidebarOverlay = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: ${(props) => (props.$isOpen ? "block" : "none")};
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1035;
  }
`;

const TourButton = styled(Button)`
  && {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 1000;
    background-color: #3f51b5;
    color: white;
    border-radius: 50px;
    padding: 10px 20px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    display: flex;
    align-items: center;
    gap: 8px;
    
    &:hover {
      background-color: #303f9f;
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
    }
    
    @media (max-width: 768px) {
      bottom: 70px;
      right: 15px;
      padding: 8px 16px;
      font-size: 14px;
    }
  }
`;
//admin.js
function Dashboard(props) {
  const { t } = useTranslation();
  const [backgroundColor, setBackgroundColor] = useState("black");
  const [activeColor, setActiveColor] = useState("info");
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const { formData, loading, error } = useFetchRecruiter();
  const mainPanel = useRef();
  const location = useLocation();
  const { videoCallLaunched, setVideoCallLaunched } = useContext(VideoCallContext);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  // const { startTour, startTourForRoute, completedTours } = useTour();
  const user = useUserId();

  // // Auto-start tour for first-time visitors
  // useEffect(() => {
  //   const hasSeenDashboardTour = localStorage.getItem('tour_/dashboard');
    
  //   if (!hasSeenDashboardTour) {
  //     // Add a small delay to ensure all elements are rendered
  //     const timer = setTimeout(() => {
  //       startTourForRoute('/dashboard');
  //       // Note: We don't set localStorage here anymore, it's set when the tour completes
  //     }, 1000);
      
  //     return () => clearTimeout(timer);
  //   }
  // }, [startTourForRoute]);

  const [currentTitle, setCurrentTitle] = useState('');
  useEffect(() => {
    console.log('currentTitle',currentTitle)
  }, [currentTitle]);
  
  useEffect(() => {
    const matchedRoute = routes.find((route) => {
      const fullPath = `${route.layout}${route.path}`;
      // For routes with basePath, check if the current pathname starts with the base path
      if (route.basePath) {
        const isBaseMatch = location.pathname.startsWith(`${route.layout}${route.basePath}`);
        if (isBaseMatch && route.children) {
          // Check if we're in a child route
          const childPath = location.pathname.replace(`${route.layout}${route.basePath}/`, '');
          const childRoute = route.children.find(child => {
            if (child.path.includes('*')) {
              return childPath.startsWith(child.path.replace('/*', ''));
            }
            return matchPath(`${route.basePath}/${child.path}`, location.pathname);
          });
          
          if (childRoute && location.pathname.includes('/post/')) {
            // Special handling for post details view
            const segments = location.pathname.split('/');
            const isPostDetails = segments[segments.length - 1] !== 'PostDetails';
            return isPostDetails ? 'Offers > Details' : route.name;
          }
        }
        return isBaseMatch;
      }
      // For other routes, use exact matching
      return matchPath(fullPath, location.pathname);
    });
  
    setCurrentTitle(matchedRoute?.name ? t(`routes.${matchedRoute.name.toLowerCase().replace(" ", "_")}`) : '');
  }, [location.pathname]);


  // Perfect Scrollbar effect
  useEffect(() => {
    console.log('isSidebarCollapsed', isSidebarCollapsed)
  }, [isSidebarCollapsed])
  useEffect(() => {
    let ps;
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current);
      document.body.classList.toggle("perfect-scrollbar-on");
    }
    return () => {
      if (ps) {
        ps.destroy();
        document.body.classList.toggle("perfect-scrollbar-on");
      }
    };
  }, []);

  // Scroll to top on route change
  useEffect(() => {
    // Use Perfect Scrollbar to scroll to top if available, otherwise use native scrolling
    if (mainPanel.current && mainPanel.current.scrollTop !== undefined) {
      mainPanel.current.scrollTop = 0;
    } else {
      mainPanel.current.scrollTop = 0;
    }
    document.scrollingElement.scrollTop = 0;
  }, [location]);

  // Slow scroll down by 100px over 800ms when page loads
  useEffect(() => {
    console.log('Slow scroll effect triggered');
    
    // Simple approach - just scroll down after a delay
    const timer = setTimeout(() => {
      console.log('Timer triggered, scrolling down');
      
      // Try multiple methods
      if (mainPanel.current) {
        console.log('Main panel ref exists, scrolling down');
        mainPanel.current.scrollTop = 70;
        console.log('Set ref scrollTop to 70');
      }
      
      // Try by ID
      const scrollContainer = document.getElementById('main-scroll-panel');
      if (scrollContainer) {
        console.log('Found scroll container by ID, scrolling down');
        scrollContainer.scrollTop = 70;
        console.log('Set container scrollTop to 70');
      }
      
      // Try window scroll
      window.scrollBy(0, 70);
      console.log('Scrolled window by 100px');
      
    }, 2000);
    
    return () => {
      console.log('Cleaning up scroll effect');
      clearTimeout(timer);
    };
  }, [location]);

  useEffect(() => {
    console.log('access!');
    if (videoCallLaunched) {
      console.log('video call launched!');

      setIsSidebarCollapsed(true);
      console.log('side bar collapsed!');
    }
  }, [videoCallLaunched]);
  useEffect(() => {
    console.log('videoCallLaunched!', videoCallLaunched);

  }, [videoCallLaunched]);

  // Handle window resize for responsiveness
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setIsSidebarCollapsed(false);
      } else {
        setIsSidebarCollapsed(window.innerWidth <= 1024);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    const panel = mainPanel.current;

    let isBouncing = false;

    const handleScroll = () => {
      if (
        panel.scrollTop === 0 ||
        panel.scrollTop + panel.clientHeight === panel.scrollHeight
      ) {
        if (!isBouncing) {
          isBouncing = true;
          panel.style.transform = "scale(1.02)";
          setTimeout(() => {
            panel.style.transform = "scale(1)";
            isBouncing = false;
          }, 300);
        }
      }
    };

    panel.addEventListener("scroll", handleScroll);

    return () => {
      panel.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleActiveClick = (color) => {
    setActiveColor(color);
  };

  const handleBgClick = (color) => {
    setBackgroundColor(color);
  };

  const handleMenuClick = () => {
    setIsMobileSidebarOpen(!isMobileSidebarOpen);
  };

  // const handleStartTour = () => {
  //   // Map the current route to the tour steps
  //   const routePath = location.pathname.replace('/talent', '');
  //   startTourForRoute(routePath);
  // };

  return (
    <>
      <Wrapper>
        <Sidebar
          {...props}
          routes={routes}
          activeColor={activeColor}
          isMobile={isMobileSidebarOpen}
          isSidebarCollapsed={isSidebarCollapsed}
          onClose={() => setIsMobileSidebarOpen(false)}
          onOpen={() => setIsMobileSidebarOpen(true)}
          setIsSidebarCollapsed={setIsSidebarCollapsed}
        />
        <MainPanel
          ref={mainPanel}
          id="main-scroll-panel"
          isSidebarCollapsed={isSidebarCollapsed}
          style={{ backgroundColor: "#F4F5F7" }}
        >
          <NavbarWrapper $isSidebarCollapsed={isSidebarCollapsed}>
            <DemoNavbar {...props} />
          </NavbarWrapper>
          <ContentWrapper>
            <Navbar 
              title={currentTitle} 
              formData={formData} 
              onMenuClick={handleMenuClick}
            />
            <Routes>
              {routes.map((prop, key) => {
                const path = prop.path.endsWith('/*') ? prop.path : `${prop.path}/*`;
                return (
                  <Route
                    path={path}
                    element={prop.component}
                    key={key}
                  />
                );
              })}
            </Routes>
          </ContentWrapper>
          <Footer fluid />
        </MainPanel>
        {/* <TourButton onClick={handleStartTour}>
          {/* <Map size={18} /> 
          {t('Take Tour')}
        </TourButton> */}
        
        {/* AI Assistant - Only show for recruiters */}
        {user.role === 'r' && (
          <AIAssistant 
            userRole={user.role}
            currentPage={currentTitle}
            candidateCount={0} // You can pass actual candidate count if available
          />
        )}
      </Wrapper>
    </>
  );
}

export default Dashboard;